import React, { useEffect, useState } from 'react'
// import { useNavigate } from 'react-router-dom'
import TimerImg from "../assets/Timer.svg"


function GamePassCard(props) {
    const {GamePassData} = props
    // const navigate = useNavigate()
    const [expiryStatus,setExpiryStatus] = useState()
    const [remainingTime,setRemainingTime] = useState()
    const [donePercent, setDonePercent] = useState((GamePassData.valueConsumed/GamePassData.maxValue)*100);

    // const handleViewDetailsButton = (voucherId)=>{
    //     window.sessionStorage.setItem("voucherId",voucherId)
    //     navigate("/ViewDetails")

    // }


    useEffect(() => {

        let startDate = new Date(GamePassData.startDate);
        let currentDate = new Date()
        let endDate = new Date(GamePassData.endDate);
        let totalSeconds = (endDate.getTime()- currentDate.getTime()) / 1000;
        let timeR

        let days = Math.floor(totalSeconds / (3600 * 24));
        let hours = Math.floor(totalSeconds % (3600 * 24) / 3600);
        let minutes = Math.floor(totalSeconds % 3600 / 60);
        let seconds = Math.floor(totalSeconds % 60);
        timeR = hours +"h" + " " + minutes + "m"
        console.log("startDate>>",startDate,currentDate,totalSeconds)
        // if(startDate <= currentDate && currentDate < endDate && days <= 0 )
        // {
        //     console.log("expiresin")
        //     setExpiryStatus("expiresin")
        //     setRemainingTime(timeR)
        // }
        // else if(startDate <= currentDate && currentDate < endDate && days > 0){
        //     console.log("expireson")
        //     setExpiryStatus("expiresOn")
        // }
        // else if(startDate > currentDate){
        //     console.log("StartsOn")
        //     setExpiryStatus("StartsOn")
        // }
        setExpiryStatus("expiresOn")

    }, [])
    const Progress = ({ done }) => {
        const [style, setStyle] = useState(
            {
                opacity: 1,
                width: `${done}%`
            });
        console.log("Came into progress")
        // setShowPercent(false)
        // setTimeout(() => {
        //     const newStyle = {
        //         opacity: 1,
        //         width: `${done}%`
        //     }

        //     setStyle(newStyle);
        // }, 200);

        return (
            <div className="progress">
                <div className="progress-done" style={style}>
                    {/* {done}% */}
                </div>
            </div>
        )
    }
  return (
    // style={{color: GamePassData.gamePassTag!=="" && "var(--Primary-Blue, #032146)"}}
    <div className='eachGameCard' style={{border:  expiryStatus === "StartsOn" ? "2px solid rgba(30, 57, 100, 0.25)" : "2px solid #1E3964",display:"flex",justifyContent:"center",alignItems:"center"}} >
       { GamePassData.gamePassTag !== "" && <div className='specialTagDiv'>
            <div className='specialTag'>{GamePassData.gamePassTag.toLocaleUpperCase()}</div>
            <div className='specialTagcurve'></div>
        </div>}
        <div className= {"eachGameCardLeft"} >
            <div className='eachGameCardLeftData'>
                <div className='eachGameCardLeftTop' >
                    <div className='eachGameCardLeftTopone'>{GamePassData.displayTitle1}</div>
                    {/* <div className='eachGameCardLeftTopone'>{GamePassData.displayTitle1}</div> */}
                    <div className='eachGameCardLeftToptwo'>{GamePassData.displayTitle2}</div>
                </div>
                {console.log("Expires in >>>>>>>>>>",expiryStatus)}
                {   expiryStatus === "expiresin" ? 
                      <div className='eachGameCardLeftBottom'>
                          <div className='eachGameCardLeftBottomone' >Expires in
                          </div>
                          <div className='eachGameCardLeftBottomtwo'>
                            <div><img style={{"marginRight":"4px"}}src={TimerImg}></img></div>
                              <div className='eachGameCardLeftBottomtwoTimer' >{remainingTime} </div>
                          </div>
                      </div>
                :
                expiryStatus === "expiresOn" ? 
                <div className='eachGameCardLeftBottom'>
                          <div className='eachGameCardLeftBottomone'  >Expires on
                          </div>
                          <div className='eachGameCardLeftBottomtwoExpireon'>
                              {/* <div className='eachGameCardLeftBottomtwoTimer' style={{color: GamePassData.gamePassTag !== "" && "var(--Primary-Blue, #032146)"}}>{GamePassData.expiresOnEvent} </div> */}
                              <div className='eachGameCardLeftBottomtwoTimer' >{GamePassData.expiresOn} </div>
                          </div>
                      </div>:
                      expiryStatus === "StartsOn" ? 
                      <div className='eachGameCardLeftBottom'>
                                <div className='eachGameCardLeftBottomonethree' >Starts on 
                                </div>
                                <div className='eachGameCardLeftBottomtwothree'>
                                    <div className='eachGameCardLeftBottomtwoTimer' >{GamePassData.StartsOn} </div>
                                </div>
                            </div>:
                      null
}
                      
            </div>
        </div>
        <div className='eachGameCardRight'  >

            <div style={{width:"100%",display:"flex",height:"50%",backgroundColor:"",flexDirection:"column",gap:"30%",marginTop: GamePassData.gamePassTag !== "" ? "5%" :""}}>
            <div className='eachGameCardRightTop' style={{height:"50%",display:"flex",width:"100%",backgroundColor:"",marginBottom:""}}>
                <div className='gametype'>Game Type</div>
                {/* <div className='gametypeDiv'>{GamePassData.betType.length ===1  ? (GamePassData.betType[0]) : (GamePassData.betType[0] + ", " + GamePassData.betType[1])  }
               
               {GamePassData.betType.length > 2 &&  <div className='extragametypes'>+{GamePassData.betType.length-2}</div>}
                </div> */}

<div style={{textDecoration: (GamePassData?.gameType === "Multiple") ?  "underline #032146 1px": "none"}} className='gametypeDiv'>{GamePassData?.gameType}

{/* {GamePassData.betType.length > 2 && <div className={(isExpired || isUtilised)? "extragametypes-shaded":'extragametypes'}>+{GamePassData.betType.length - 2}</div>} */}
</div>
            </div> 

            <div className='eachGameCardRightTop' style={{height:"50%",display:"flex",width:"100%"}}>
                <div className='gametype'>{GamePassData?.showEntry ? "Entry" : "Pt. Value"}</div>
                {/* <div className='gametypeDiv'>{GamePassData.entryAmount.length === 1 ? (GamePassData.entryAmount[0]) : (GamePassData.entryAmount[0] + ", " + GamePassData.entryAmount[1] ) }
               
               {GamePassData.entryAmount.length > 2 &&  <div className='extragametypes'>+{GamePassData.entryAmount.length-2}</div>}
                </div> */}

<div style={{textDecoration: (GamePassData?.entryType === "Multiple") ?  "underline #032146 1px": "none"}} className='gametypeDiv'>{GamePassData?.entryType}
                              </div>
            </div> 
</div>
            <div className='eachGameCardRightBottom' style={{marginTop:"5%"}} > 
                <div className='progressBarDiv' style={{marginTop:"15%"}}>
                       <Progress done = {donePercent}/>
                    <div className='Gameleft'>{GamePassData.progressText}</div>
                </div>
                {/* <div className='viewDetailsButton' style={{"background" : expiryStatus === "StartsOn" ?  "linear-gradient(180deg, #58B6C6 0%, #3A4C71 100%)" : "linear-gradient(180deg, #42BE40 0%, #196A29 100%)"}} onClick = {()=>{handleViewDetailsButton(GamePassData.voucherId)}}>View Details</div> */}
            </div>
        </div>
        <div className='redeemExpiryStamp' > 
            <span style={{ fontSize:'0.75rem', fontWeight:'700', rotate:'15 deg'}}> EXPIRES ON REDEEM </span>
        </div>
    </div>
  )
}

export default GamePassCard